import Repository from "@/services/Repository";

const resource = "/reports";

export default {
  topics({ classroom, studyClass, schoolYear }) {
    let params = {
      classroom,
      studyClass,
      schoolYear
    };
    return Repository.get(`${resource}/class-topics`, { params });
  },
  topicsClassroom({ classroom, studyClass, schoolYear }) {
    let params = {
      classroom,
      studyClass,
      schoolYear
    };
    return Repository.get(`${resource}/student-class-topics`, { params });
  },
  attributes({ classroom, studyClass, schoolYear }) {
    let params = {
      classroom,
      studyClass,
      schoolYear
    };
    return Repository.get(`${resource}/class-attributes`, { params });
  },
  attributesClassroom({ classroom, studyClass, schoolYear }) {
    let params = {
      classroom,
      studyClass,
      schoolYear
    };
    return Repository.get(`${resource}/student-class-attributes`, { params });
  },
  rollCallByStudent({ studentIds, schoolYear }) {
    let params = { studentIds, schoolYear };
    return Repository.get(`${resource}/students-rollcall-summary`, { params });
  },
  attendantStudent({ student, schoolYear, term }) {
    let params = { student, schoolYear, term };
    return Repository.get(`${resource}/student-attendants `, { params });
  },
  studentsDevelopment({ classroom, schoolYear }) {
    let params = { classroom, schoolYear };
    return Repository.get(`${resource}/students-development-score`, {
      params
    });
  },
  classroomAttributesSummary({ classroom, schoolYear }) {
    let params = { classroom, schoolYear };
    return Repository.get(`${resource}/classroom-attributes`, {
      params
    });
  },
  classroomTopicsSummary({ classroom, schoolYear, term }) {
    let params = { classroom, schoolYear, term };
    return Repository.get(`${resource}/classroom-topics`, {
      params
    });
  },
  studyClassTopicsSummary({ studyClass, schoolYear }) {
    let params = { studyClass, schoolYear };
    return Repository.get(`${resource}/studyclass-topics`, {
      params
    });
  },
  classroomFormRecordedCount({ classroom, schoolYear, term, time }) {
    let params = { classroom, schoolYear, term, time };
    return Repository.get(`${resource}/classroom-forms-count`, {
      params
    });
  },
  studyClassTopicsProgress({ schoolYear, studyClass }) {
    let params = { schoolYear, studyClass };
    return Repository.get(`${resource}/studyclass-topics-progress`, {
      params
    });
  },
  classroomTopicsProgress({ classroom, schoolYear, studyClass, term }) {
    let params = { classroom, schoolYear, studyClass, term };
    return Repository.get(`${resource}/classroom-topics-progress`, {
      params
    });
  },
  studentAttributesSummary({ student, schoolYear }) {
    let params = { student, schoolYear };
    return Repository.get(`${resource}/student-attributes`, {
      params
    });
  },
  studentTopicsSummary({ student, schoolYear }) {
    let params = { student, schoolYear };
    return Repository.get(`${resource}/student-topics`, {
      params
    });
  },
  studentTopicsProgress({ student, schoolYear, studyClass }) {
    let params = { student, schoolYear, studyClass };
    return Repository.get(`${resource}/student-topics-progress`, {
      params
    });
  },
  studentRollcallRatio({ schoolYear, student }) {
    let params = { schoolYear, student };
    return Repository.get(`${resource}/student-rollcall`, {
      params
    });
  },
  studentsRollcallRatio({ schoolYear, students }) {
    let params = { schoolYear, students };
    return Repository.get(`${resource}/students-rollcall`, {
      params
    });
  },
  classroomStudentAmount({ schoolYear, classroom }) {
    let params = { schoolYear, classroom };
    return Repository.get(`${resource}/classroom-student-amount`, {
      params
    });
  },
  classroomRollcallSummary({ schoolYear, classroom }) {
    let params = { schoolYear, classroom };
    return Repository.get(`${resource}/classroom-rollcall-summary`, {
      params
    });
  },
  classroomRollcallRatio({ classroom, schoolYear }) {
    let params = { classroom, schoolYear };
    return Repository.get(`${resource}/classroom-rollcall`, { params });
  },
  studyClassRollcallRatio({ schoolYear }) {
    let params = { schoolYear };
    return Repository.get(`${resource}/studyClass-rollcall`, { params });
  },
  studyClassGradeConfirmedProgress({ schoolYear, term }) {
    let params = { schoolYear, term };
    return Repository.get(`${resource}/studyClass-confirm-progress`, {
      params
    });
  },
  classroomGradeConfirmedProgress({ classroom, schoolYear, term }) {
    let params = { classroom, schoolYear, term };
    return Repository.get(`${resource}/classroom-confirm-progress`, {
      params
    });
  },
  //
  schoolStudentGenders({ schoolYear }) {
    let params = { schoolYear };
    return Repository.get(`${resource}/dashboard/school/student-gender`, {
      params
    });
  },
  schoolStudentLocals({ schoolYear }) {
    let params = { schoolYear };
    return Repository.get(`${resource}/dashboard/school/student-local`, {
      params
    });
  },
  schoolStudentAttendances({ schoolYear, term }) {
    let params = { schoolYear, term };
    return Repository.get(`${resource}/dashboard/school/student-attendance`, {
      params
    });
  },
  schoolStudentDevelopments({ schoolYear }) {
    let params = { schoolYear };
    return Repository.get(`${resource}/dashboard/school/student-development`, {
      params
    });
  },
  schoolDevelopmentProgress({ schoolYear, term }) {
    let params = { schoolYear, term };
    return Repository.get(`${resource}/dashboard/school/development-progress`, {
      params
    });
  },
  schoolCrews() {
    return Repository.get(`${resource}/dashboard/school/crew`);
  },
  schoolStudentsPerTeacher({ schoolYear }) {
    let params = { schoolYear };

    return Repository.get(`${resource}/dashboard/school/students-per-teacher`, {
      params
    });
  },
  schoolClassrooms({ schoolYear }) {
    let params = { schoolYear };

    return Repository.get(`${resource}/dashboard/school/classroom`, {
      params
    });
  },
  schoolStudentsPerClassroom({ schoolYear }) {
    let params = { schoolYear };

    return Repository.get(
      `${resource}/dashboard/school/students-per-classroom`,
      {
        params
      }
    );
  },
  schoolAdminTask({ schoolYear }) {
    let params = { schoolYear };
    return Repository.get(`${resource}/dashboard/school/admin-task`, {
      params
    });
  },
  classroomTeacherTask({ schoolYear, classroom, term }) {
    let params = { schoolYear, classroom, term };
    return Repository.get(`${resource}/dashboard/classroom/teacher-task`, {
      params
    });
  },
  classroomStudentAttendances({ startAt, endAt, classroom }) {
    let params = { startAt, endAt, classroom };
    return Repository.get(
      `${resource}/dashboard/classroom/student-attendance`,
      {
        params
      }
    );
  }
};
